var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _feColorMatrix, _feColorMatrix2, _feColorMatrix3, _feColorMatrix4, _feColorMatrix5, _feColorMatrix6, _feColorMatrix7, _feColorMatrix8, _feColorMatrix9, _feColorMatrix10, _feColorMatrix11, _feColorMatrix12, _feColorMatrix13, _feColorMatrix14, _feColorMatrix15, _feColorMatrix16, _feColorMatrix17, _feColorMatrix18, _feColorMatrix19, _feColorMatrix20, _feColorMatrix21, _feColorMatrix22, _feColorMatrix23, _feColorMatrix24, _script;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro2024Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115.464,
    height: 152.145,
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21837 0 0 .21837 17.575 -.186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.318 390.201 4.691-7.933h1.751v15.131h-1.687v-12.04h-.042l-3.956 6.658h-1.557l-3.977-6.658h-.043v12.04h-1.686v-15.131h1.751l4.712 7.933zm-13.809 7.198h-1.73v-13.661h-4.647v-1.47h11.002v1.47h-4.625z",
    style: {
      fill: "#0d4d8e",
      fillRule: "nonzero"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.555 2.881c-116.082 0-165.456 91.313-165.456 203.952 0 112.641 49.374 204.14 165.456 204.14 116.083 0 165.457-91.499 165.457-204.14 0-112.639-49.374-203.952-165.457-203.952Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.169 30.414c-12.982-9.244-27.847-16.386-44.694-21.046l-49.14 200.361z",
    style: {
      fill: "#f05549",
      fillRule: "nonzero",
      filter: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.335 209.729 305.779 64.407c-9.441-13.328-20.721-24.884-33.964-34.251Z",
    style: {
      fill: "#fec23d",
      fillRule: "nonzero",
      filter: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.335 209.729 148.912-104.268c-5.635-14.991-12.771-28.773-21.468-41.053Z",
    style: {
      fill: "#0d4d8e",
      fillRule: "nonzero",
      filter: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.475 9.368c-14.826-4.101-31.18-6.287-49.14-6.287v206.648z",
    style: {
      fill: "#00ab54",
      fillRule: "nonzero",
      filter: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.28 382.79-94.945-173.061 45.701 195.867c18.759-4.75 35.128-12.522 49.244-22.806z",
    style: {
      fill: "#00ab54",
      fillRule: "nonzero",
      filter: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28 382.79c12.747-9.287 23.652-20.624 32.805-33.648l-127.75-139.413Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      filter: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.084 349.142c8.447-12.018 15.407-25.464 20.943-40.061l-148.692-99.352Z",
    style: {
      fill: "#fec23d",
      fillRule: "nonzero",
      filter: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41 267.991c2.428-12.899 4.02-26.346 4.804-40.205l-164.879-18.057Z",
    style: {
      fill: "#f05549",
      fillRule: "nonzero",
      filter: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.661 147.381c-2.7-14.752-6.483-28.798-11.414-41.921L178.335 209.729Z",
    style: {
      fill: "#252524",
      fillRule: "nonzero",
      filter: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.301 188.011c-.721-14.002-2.254-27.593-4.64-40.63l-160.326 62.348z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      filter: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.213 227.786c.387-6.824.578-13.747.578-20.753 0-6.415-.168-12.758-.49-19.023l-164.965 21.719z",
    style: {
      fill: "#00ab54",
      fillRule: "nonzero",
      filter: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.027 309.081c4.881-12.873 8.66-26.635 11.383-41.09l-160.075-58.262Z",
    style: {
      fill: "#0d4d8e",
      fillRule: "nonzero",
      filter: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.501 30.414c12.981-9.244 27.848-16.386 44.695-21.046l49.139 200.361z",
    style: {
      fill: "#252524",
      fillRule: "nonzero",
      filter: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.335 209.729 50.891 64.407c9.44-13.328 20.721-24.884 33.964-34.251Z",
    style: {
      fill: "#fec23d",
      fillRule: "nonzero",
      filter: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.335 209.729 29.423 105.461c5.635-14.991 12.771-28.773 21.468-41.053Z",
    style: {
      fill: "#f05549",
      fillRule: "nonzero",
      filter: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.196 9.368c14.825-4.101 31.179-6.287 49.139-6.287v206.648Z",
    style: {
      fill: "#fec23d",
      fillRule: "nonzero",
      filter: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.39 382.79 94.945-173.061-45.701 195.867c-18.758-4.75-35.128-12.522-49.244-22.806Z",
    style: {
      fill: "#fec23d",
      fillRule: "nonzero",
      filter: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39 382.79c-12.747-9.287-23.652-20.624-32.806-33.648l127.751-139.413Z",
    style: {
      fill: "#f05549",
      fillRule: "nonzero",
      filter: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.586 349.142c-8.448-12.018-15.407-25.464-20.943-40.061l148.692-99.352z",
    style: {
      fill: "#252524",
      fillRule: "nonzero",
      filter: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.26 267.991c-2.428-12.899-4.021-26.346-4.804-40.205l164.879-18.057Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      filter: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.009 147.381c2.7-14.752 6.483-28.798 11.414-41.921l148.912 104.269z",
    style: {
      fill: "#fff",
      fillRule: "nonzero",
      filter: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.368 188.011c.722-14.002 2.255-27.593 4.641-40.63l160.326 62.348z",
    style: {
      fill: "#0d4d8e",
      fillRule: "nonzero",
      filter: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.456 227.786a367.596 367.596 0 0 1-.577-20.753c0-6.415.167-12.758.49-19.023l164.966 21.719z",
    style: {
      fill: "#f05549",
      fillRule: "nonzero",
      filter: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.643 309.081c-4.882-12.873-8.66-26.635-11.383-41.09l160.075-58.262Z",
    style: {
      fill: "#00ab54",
      fillRule: "nonzero",
      filter: "url(#y)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.334 86.237s54.85 1.888 56.021-1.312c1.243-3.395 5.779-17.991 5.779-27.597 0-17.316-17.444-25.296-22.617-27.879-13.09-6.534-27.983-7.789-39.183-7.789s-26.094 1.255-39.183 7.789c-5.173 2.583-22.618 10.563-22.618 27.879 0 9.606 4.536 24.202 5.779 27.597 1.171 3.2 56.022 1.312 56.022 1.312z",
    style: {
      fill: "#c6d8e3",
      fillRule: "nonzero"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.334 86.237s54.85 1.888 56.021-1.312c1.243-3.395 5.779-17.991 5.779-27.597 0-17.316-17.444-25.296-22.617-27.879-13.09-6.534-27.983-7.789-39.183-7.789s-26.094 1.255-39.183 7.789c-5.173 2.583-22.618 10.563-22.618 27.879 0 9.606 4.536 24.202 5.779 27.597 1.171 3.2 56.022 1.312 56.022 1.312z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.604 79.235c-11.329-4.197-23.828-10.346-24.792-13.164-1.067-3.117-4.417-15.42-5.72-21.154a104.625 104.625 0 0 1-.521-2.378c5.436-7.228 13.788-11.209 17.33-12.965-.083.827.004 2.156.489 4.291 1.303 5.734 3.712 18.931 4.966 21.977 1.038 2.518 11.29 9.422 20.273 15.105-5.806 1.829-10.179 4.783-12.025 8.288zM204.122 79.253c-1.837-3.505-6.201-6.461-11.997-8.294 8.987-5.685 19.254-12.597 20.292-15.117 1.255-3.046 3.663-16.243 4.966-21.977.475-2.088.568-3.405.495-4.236 3.62 1.792 11.924 5.797 17.302 13.021-.12.587-.285 1.326-.499 2.267-1.303 5.734-4.652 18.037-5.719 21.154-.967 2.822-13.498 8.984-24.84 13.182z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.337 48.863c33.173 0 63.56 16.738 55.897 36.399-3.851 9.881-24.421 23.171-55.897 23.171s-52.047-13.29-55.898-23.171c-7.662-19.661 22.724-36.399 55.898-36.399z",
    style: {
      fill: "#3c7792",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.933 65.419c7.539 0 10.447 1.355 13.111 2.237 2.417.801 8.822 1.382 11.92-2.573 3.169-4.047 9.467-4.113 15.974-2.433 0 0-10.379-11.488-41.005-11.488-30.626 0-41.005 11.488-41.005 11.488 6.507-1.68 12.806-1.614 15.975 2.433 3.097 3.955 9.502 3.374 11.919 2.573 2.664-.882 5.573-2.237 13.111-2.237z",
    style: {
      fill: "#6098c1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.662 131.362c-1.131-5.046-.047-15.058 3.069-20.391 7.595-13.001 23.365-10.433 33.055-3.959V93.294c-5.578-5.988-27.095-8.489-39.581 2.782-16.428 14.827-10.698 52.897-10.698 52.897z",
    style: {
      fill: "url(#A)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.662 131.362c-1.131-5.046-.047-15.058 3.069-20.391 7.595-13.001 23.365-10.433 33.055-3.959V93.294c-5.578-5.988-27.095-8.489-39.581 2.782-16.428 14.827-10.698 52.897-10.698 52.897z",
    style: {
      fill: "#c6d8e3",
      fillRule: "nonzero"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.662 131.362c-1.131-5.046-.047-15.058 3.069-20.391 7.595-13.001 23.365-10.433 33.055-3.959V93.294c-5.578-5.988-27.095-8.489-39.581 2.782-16.428 14.827-10.698 52.897-10.698 52.897z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.3 136.17s-4.808-25.521 10.172-34.398c14.98-8.877 28.314 2.433 28.314 2.433l-9.451 22.348z",
    style: {
      fill: "#6098c1",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.161 148.973s5.729-38.07-10.698-52.897c-12.487-11.271-34.003-8.77-39.581-2.782v13.718c9.69-6.474 25.459-9.042 33.055 3.959 3.116 5.333 4.2 15.345 3.068 20.391z",
    style: {
      fill: "url(#C)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.161 148.973s5.729-38.07-10.698-52.897c-12.487-11.271-34.003-8.77-39.581-2.782v13.718c9.69-6.474 25.459-9.042 33.055 3.959 3.116 5.333 4.2 15.345 3.068 20.391z",
    style: {
      fill: "#c6d8e3",
      fillRule: "nonzero"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.161 148.973s5.729-38.07-10.698-52.897c-12.487-11.271-34.003-8.77-39.581-2.782v13.718c9.69-6.474 25.459-9.042 33.055 3.959 3.116 5.333 4.2 15.345 3.068 20.391z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.367 136.17s4.808-25.521-10.171-34.398c-14.98-8.877-28.314 2.433-28.314 2.433l9.45 22.348z",
    style: {
      fill: "#6098c1",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.358 68.956c-14.756 0-26.717 6.279-26.717 14.025v63.76h53.435v-63.76c0-7.746-11.962-14.025-26.718-14.025z",
    style: {
      fill: "#c6d8e3",
      fillRule: "nonzero"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.309 68.956c-14.756 0-26.718 6.279-26.718 14.025v63.76h53.436v-63.76c0-7.746-11.962-14.025-26.718-14.025z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.472 111.446V76.828c0-4.159 3.001-5.575 7.101-6.269l3.916-.663s-3.954-.349-4.032 4.375c-.079 4.724-.152 24.118.017 26.307.388 5.041 2.755 8.872 4.487 8.793 1.732-.079-11.489 2.075-11.489 2.075zM199.147 111.446V76.828c0-4.159-3.002-5.575-7.102-6.269l-3.916-.663s3.954-.349 4.032 4.375c.079 4.724.152 24.118-.017 26.307-.388 5.041-2.755 8.872-4.487 8.793-1.732-.079 11.49 2.075 11.49 2.075z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.008 350.015c-17.57 24.148-40.307 40.917-67.9 50.231-.226-1.451-.815-3.117-1.715-4.897-2.19-4.331-18.797-32-21.509-48.31-3.508-21.104 7.257-33.82 19.033-60.016 13.677-30.428 37.188-88.714 27.947-125.477-10.201-40.574-49.162-53.325-80.53-53.325-31.367 0-70.329 12.751-80.529 53.325-9.242 36.763 14.27 95.049 27.947 125.477 11.776 26.196 22.541 38.912 19.033 60.016-2.712 16.31-19.319 43.979-21.509 48.31-.901 1.78-1.49 3.446-1.715 4.897-27.594-9.313-50.332-26.082-67.902-50.231-25.4-34.911-38.827-84.39-38.827-143.088 0-58.727 13.406-108.205 38.766-143.088C82.025 24.738 123.993 4.912 178.334 4.912c54.341 0 96.308 19.826 124.736 58.927 25.359 34.883 38.764 84.361 38.764 143.088 0 58.697-13.426 108.177-38.826 143.088zm3.346-288.564C277.12 21.24 234.048.85 178.334.85c-55.713 0-98.787 20.389-128.021 60.601-25.868 35.581-39.542 85.885-39.542 145.476 0 59.562 13.695 109.867 39.604 145.477 19.269 26.484 44.547 44.33 75.443 53.454.86.279 1.914.616 3.186.995.697.208 1.554.11 2.479.012.972-.103 2.017-.206 3.029.046 1.561.39 2.888 2.127 4.802 2.522 8.923 1.842 21.737 3.571 39.013 3.571h.014c17.276 0 30.091-1.729 39.014-3.571 2.166-.448 3.962-2.368 5.678-2.805.874-.223 1.727-.061 2.524.101.766.155 1.479.311 2.108.124 1.272-.379 2.327-.717 3.187-.995 30.895-9.125 56.172-26.971 75.44-53.454 25.909-35.61 39.604-85.915 39.604-145.477 0-59.591-13.674-109.895-39.542-145.476z",
    style: {
      fill: "#c6d8e3",
      fillRule: "nonzero"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.341 413.004c33.353 0 50.078-6.443 54.273-7.71 3.41-1.029 3.247-5.065.779-9.945-2.19-4.331-18.797-32-21.509-48.31-3.508-21.104 7.257-33.82 19.033-60.016 13.677-30.428 37.188-88.714 27.947-125.477-10.201-40.574-49.162-53.325-80.53-53.325-31.367 0-70.329 12.751-80.529 53.325-9.242 36.763 14.27 95.049 27.947 125.477 11.776 26.196 22.541 38.912 19.033 60.016-2.712 16.31-19.319 43.979-21.509 48.31-2.468 4.88-2.631 8.916.779 9.945 4.195 1.267 20.92 7.71 54.272 7.71z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.314 409.433a122.588 122.588 0 0 1-10.31-2.58c.302.09.635.123.99.123.463 0 .965-.056 1.489-.111a15.18 15.18 0 0 1 1.616-.111c.471 0 .946.041 1.413.157 1.561.39 2.888 2.127 4.802 2.522z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.314 409.433c-1.914-.395-3.241-2.132-4.802-2.522a5.843 5.843 0 0 0-1.413-.157c-.549 0-1.093.055-1.616.111-.524.055-1.026.111-1.489.111-.355 0-.688-.033-.99-.123.681-3.641 2.056-7.49 4.622-11.366 9.398-14.19 14.63-31.782 16.918-41.687 7.618-32.971-27.686-59.306-41.767-153.181-10.752-71.682 36.928-84.81 52.332-86.614l6.098-.854c-55.899 19.276-41.373 101.511-29.933 141.918 14.46 51.068 23.835 72.594 21.223 98.378-.808 7.978-5.975 27.273-13.912 42.018-2.836 5.267-4.395 7.252-5.271 13.968zM217.355 409.433c2.166-.448 3.962-2.368 5.678-2.805.307-.079.612-.109.912-.109.555 0 1.095.105 1.612.21.516.105 1.009.209 1.467.21.222 0 .436-.025.641-.086a122.982 122.982 0 0 1-10.31 2.58z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.355 409.433c-.876-6.716-2.435-8.701-5.271-13.968-7.938-14.745-13.104-34.04-13.912-42.018-2.612-25.784 6.763-47.31 21.222-98.378 11.441-40.407 25.967-122.642-29.932-141.918l6.098.854c15.404 1.804 63.084 14.932 52.332 86.614-14.081 93.875-49.385 120.21-41.767 153.181 2.288 9.905 7.52 27.497 16.917 41.687 2.567 3.876 3.942 7.725 4.623 11.366a2.235 2.235 0 0 1-.641.086c-.458-.001-.951-.105-1.467-.21-.517-.105-1.057-.21-1.612-.21-.3 0-.605.03-.912.109-1.716.437-3.512 2.357-5.678 2.805z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.334 184.737c-10.571 0-20.812.45-30.606 1.301.619-16.351 14.107-29.464 30.606-29.464 16.5 0 29.988 13.113 30.607 29.464-9.794-.851-20.036-1.301-30.607-1.301zm0 33.11c-15.592 0-28.491-11.711-30.387-26.797a335.867 335.867 0 0 1 30.387-1.366c10.431 0 20.613.476 30.388 1.366-1.896 15.086-14.795 26.797-30.388 26.797zm35.566-31.339c-.376-19.297-16.18-34.881-35.566-34.881-19.385 0-35.189 15.584-35.565 34.881-56.169 5.747-96.363 24.884-96.363 48.238h4.947c0-20.099 39.374-37.628 91.67-43.21 2.143 17.587 17.156 31.258 35.311 31.258 18.156 0 33.169-13.671 35.312-31.258 52.296 5.582 91.669 23.111 91.669 43.21h4.947c0-23.353-40.194-42.49-96.362-48.238z",
    style: {
      fill: "#6098c1",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.17 403.238s6.489-49.589 21.164-49.589 21.164 49.589 21.164 49.589c-23.531 5.429-42.328 0-42.328 0z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "b",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "c",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "d",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "e",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "f",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "g",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "h",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "i",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "j",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "k",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "l",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "m",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "n",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix13 || (_feColorMatrix13 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "o",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix14 || (_feColorMatrix14 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "p",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix15 || (_feColorMatrix15 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "q",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix16 || (_feColorMatrix16 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "r",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix17 || (_feColorMatrix17 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "s",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix18 || (_feColorMatrix18 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "t",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix19 || (_feColorMatrix19 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "u",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix20 || (_feColorMatrix20 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "v",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix21 || (_feColorMatrix21 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "w",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix22 || (_feColorMatrix22 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "x",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix23 || (_feColorMatrix23 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "y",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix24 || (_feColorMatrix24 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1.5 0 0 -7.97973e-18 -0.25 0 1.5 0 -7.97973e-18 -0.25 0 0 1.5 -7.97973e-18 -0.25 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(180 75.586 59.296) scale(48.7784)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6098c1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c6d8e3",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(48.7784 0 0 -48.7784 205.496 118.592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6098c1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c6d8e3",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.407 110.12c.104-.91-.174-1.758-.85-2.591l-3.19-3.925-1.58 1.284 2.929 3.604c.51.626.652.973.604 1.486-.035.404-.282.82-.677 1.14-.393.32-.85.476-1.253.428-.511-.058-.822-.268-1.33-.896l-2.93-3.602-1.58 1.284 3.19 3.926c.68.832 1.452 1.276 2.364 1.36.107.01.214.018.32.018.883.011 1.703-.303 2.498-.947.886-.723 1.371-1.563 1.485-2.568zm8.04-10.35-5.117 1.04a.814.814 0 0 0-.534.338.811.811 0 0 0-.104.624l1.02 5.024c.166.818.533 1.406 1.09 1.75.368.227.81.34 1.318.34.26 0 .536-.03.83-.09l3.198-.649-.385-1.896-3.111.631c-.637.13-.844.059-.99-.656l-.109-.54 3.6-.73-.381-1.875-3.6.73-.273-1.346 3.934-.798zm9.951 2.742 3.067.795.485-1.87-3.154-.817c-1.728-.448-2.912.199-3.332 1.821l-1.287 4.97a.811.811 0 0 0 .07.627.81.81 0 0 0 .513.366l1.171.303.83-3.214 3.55.92.478-1.849-3.55-.92.138-.53c.183-.705.393-.765 1.021-.602zm11.409 3.276-.311-.24c-.486-.374-.87-.214-1.151-.03l-7.284 4.714 1.904 1.077 4.643-3.003-.8 2.698-.705-.529-1.217.872 1.512 1.128-.352 1.212 1.668 1.527 2.418-8.321c.096-.293.166-.726-.325-1.104zm-18.19 4.49c-5.974 0-11.394 2.674-14.7 6.627l1.049 1.295c3.002-3.737 8.11-6.306 13.652-6.306 5.541 0 10.65 2.57 13.652 6.306l1.048-1.295c-3.306-3.953-8.726-6.626-14.7-6.626zm22.096-6.127c-6.058-5.23-13.905-8.11-22.095-8.11s-16.037 2.88-22.095 8.11a31.138 31.138 0 0 0-1.68 1.563l1.082 1.337a29.506 29.506 0 0 1 1.715-1.605c5.748-4.961 13.198-7.694 20.978-7.694 7.78 0 15.23 2.733 20.977 7.694a29.438 29.438 0 0 1 1.715 1.605l1.083-1.337a31.303 31.303 0 0 0-1.68-1.563zm17.07 31.202 2.27-2.072c2.663-2.431 4.185-4.65 4.185-6.984 0-2.884-2.18-4.957-5.536-4.957-3.402 0-5.576 2.096-5.509 5.362l2.771.158c-.09-1.735.89-2.996 2.603-2.996 1.644 0 2.72 1.036 2.674 2.658-.045 1.577-1.227 3.182-3.125 4.956-1.217 1.138-4.831 4.234-4.831 4.234v2.187h11.092v-2.546zm-24.651 0 2.27-2.072c2.663-2.431 4.184-4.65 4.184-6.984 0-2.884-2.179-4.957-5.536-4.957-3.401 0-5.576 2.096-5.509 5.362l2.772.158c-.09-1.735.89-2.996 2.602-2.996 1.645 0 2.72 1.036 2.675 2.658-.045 1.577-1.228 3.182-3.125 4.956-1.217 1.138-4.832 4.234-4.832 4.234v2.187h11.092v-2.546zm42.103-3.875v-9.912h-3.852l-6.887 10.295v2.14h5.893l.39-2.523h-3.084l4.673-7.156.002-.011v.004l.003-.004v7.164h-.002l.001 2.523h.001v3.898h2.861v-3.898h2.23v-2.523zm-52.275-1.876c0 2.628-1.343 4.432-3.472 4.814l.56 3.62c4.402-.57 7.23-3.8 7.23-8.434 0-5.097-3.45-8.502-8.66-8.502s-8.662 3.405-8.662 8.502c0 4.634 2.83 7.864 7.232 8.433l.56-3.62c-2.13-.38-3.473-2.185-3.473-4.813 0-2.926 1.715-4.891 4.342-4.891 2.628 0 4.343 1.965 4.343 4.89zm-15.022-2.697c0-3.064-2.14-5.34-6.173-5.34H31.88V137.9h4.055v-12.706h3.447c1.374 0 2.298.676 2.298 2.027 0 1.262-.766 2.65-2.298 2.65h-1.866l3.082 8.029h4.345l-2.981-5.37c2.5-.518 3.976-2.988 3.976-5.624zM0 137.899h11.76v-3.492H4.055v-2.996h7.03v-3.29h-7.03v-3.041h7.705v-3.514H0Zm87.485-8.173c0-3.998-1.014-5.835-2.952-5.835-2.072 0-2.973 2.113-2.973 5.766 0 4.044 1.013 5.881 2.973 5.881 2.05 0 2.952-2.113 2.952-5.812zm2.996 0c0 5.583-2.275 8.386-5.948 8.386-3.987 0-5.992-3.148-5.992-8.455 0-5.537 2.23-8.317 5.992-8.317 3.875 0 5.948 3.102 5.948 8.386zm-75.542-8.16h4.055v10.16c0 1.802 1.149 2.771 2.839 2.771 1.87 0 2.838-1.104 2.838-2.77v-10.161h4.033v10.318c0 3.785-2.5 6.24-6.871 6.24-4.168 0-6.894-2.298-6.894-6.24zm52.3 21.518h-1.246l-3.526 8.938h1.147l.519-1.354 1.104-2.928h.005l1.38-3.62 1.837 4.82h-2.685l.147.863h2.858l.85 2.22h1.172zM47.66 148.35c1.751-.026 2.897-.999 2.897-2.639 0-1.553-1.146-2.626-2.97-2.626h-3.983v8.938h1.048v-7.976h2.848c1.184 0 1.96.616 1.96 1.714 0 1.047-.69 1.75-1.96 1.75h-1.849l3.859 4.512h1.319zm4.414-5.265h1.208l3.402 5.388 3.353-5.388h1.196v8.938h-1.047v-7.397l-3.255 5.203h-.506l-3.304-5.208v7.402h-1.047zm35.899 0-3.255 4.711v4.227h-1.047v-4.227l-3.304-4.71h1.22l2.614 3.932 2.6-3.933zm-8.642 0v8.938h-1.134L73.18 144.7v7.323h-1.048v-8.938h1.135l5.017 7.286v-7.286zm-43.69 0h6.262v.962H36.69v3.045h4.845v.912H36.69v3.058h5.215v.961h-6.262zm-10.38 4.488c0-2.737 1.75-4.61 4.438-4.61 2.095 0 3.686 1.146 4.03 2.86h-1.084c-.358-1.135-1.529-1.9-2.934-1.9-2.047 0-3.353 1.468-3.353 3.65 0 2.194 1.319 3.637 3.378 3.637 1.836 0 3.18-1.16 3.193-2.836l.086-.05h-4.02v-.862h4.957c.024.21.049.407.049.64 0 2.417-1.701 4.044-4.266 4.044-2.724 0-4.475-1.824-4.475-4.573z",
    style: {
      fill: "#004f9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 0.950928
    }
  }), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro2024Icon);
export default __webpack_public_path__ + "static/media/euro_2024_icon.22f8262a6aa5f7eb7097038ec250e7a8.svg";
export { ForwardRef as ReactComponent };